/*var notifyRecaptchaSiteKey = $('#notify_captcha_sitekey').val();
var onloadCallback = function() {
    grecaptcha.render('html_element_notify', {
      'sitekey' : notifyRecaptchaSiteKey
    });
};*/

$(document).ready(function(){
    var language = $('.ly-custom-dropdown-current-inner').html().trim();
    if (language == 'EN') {
      var alreadyEnteredNotify = "You have already submitted your email address. Keep an eye out for our emails.";
      var optinRulesMssg = "Please check to sign up for prize drop emails.";
      var emailRequiredMssg = "Email address required";
      var invalidEmailMssg_notify = "Invalid email address";
      var successMsg = "We'll let you know when the next prize drops! Keep an eye out on your email.";
    }else{
      var alreadyEnteredNotify = "Ya temenos tu dirección de correo electrónico. Mantente al tanto de nuestros correos.";
      var optinRulesMssg = "Por favor compruebe para registrarse para recibir correos electrónicos cuando salgan nuevos premios.";
      var emailRequiredMssg = "Dirección de correo electrónico requerida";
      var invalidEmailMssg_notify = "Dirección de correo electrónico no válida";
      var successMsg = "¡Te avisaremos cuando salga nuevos premios! Mantener un ojo en su correo electrónico.";
    }

    $("#notifyForm").validate({
      rules: {
        notified_email: {
          required: true,
          emailValidate: true
        },
        optin_notify: {
          required: true
        }
      },
      messages: {
        notified_email: {
          required: emailRequiredMssg,
          emailValidate: invalidEmailMssg_notify
        },
        optin_notify: optinRulesMssg
      },
      submitHandler: function () {
        //debugger;
        var final_values = {};
        final_values['email'] = $("#notified_email").val();
        if($("#optin_notify").val() == "on"){
            final_values['optin_subscribe'] = true;
        }
        var captcha_resp = grecaptcha.getResponse(0);
        if(captcha_resp != '' && captcha_resp != null) {
            final_values['g-recaptcha-response'] = captcha_resp;
            var data = JSON.stringify(final_values);
            console.log(data);
            var settings = {
                "url": $("#notify_api_url").val(),
                "method": "POST",
                "headers": {
                    "Authorization": "Bearer "+$("#notify_api_token").val(),
                    "Content-Type": "application/json"
                },
                "dataType": "json",
                "data": data
            };
            $.ajax(settings).done(function (responseData) {
                var response = responseData;
                var cleanResponseMain = '';
                var showSuccess = false;
                var errorMessage;
                var errorMessage = 'Sorry, something went wrong.<br>Please try again.';
                // send status in url parameter for QA puporses else if no parameter then work as per API
                var urlParams = new URLSearchParams(window.location.search);
                var responseStatus = urlParams.get('status');
                if(responseStatus) {
                var responseVar = responseStatus;
                }
                else{
                var responseVar = response.status;
                }
                var responseMsg = response.redirect;
                switch (responseVar) {
                case "already_subscribe":
                    cleanResponseMain = alreadyEnteredNotify;
                    break;
                case "success":
                    showSuccess = true;
                    break;
                case "Missing Token":
                    cleanResponseMain = errorMessage;
                    break;
                case "Token Not Valid":
                    cleanResponseMain = errorMessage;
                    break;
                case "bad_request":
                    cleanResponseMain = errorMessage;
                    break;
                case "redirect":
                    if( responseMsg == "already_subscribe" ) {
                        cleanResponseMain = alreadyEnteredNotify;
                    }
                    else if( responseMsg == "success" ) {
                        showSuccess = true;
                    }
                    break;
                case "Invalid fields submitted":
                    cleanResponseMain = errorMessage;
                    break;
                }

                if (showSuccess) {
                    $('.section-popup .content').html(successMsg);
                    $('.section-popup').show();
                    $('#notifyForm')[0].reset();
                } else {
                    $('.section-popup .content').html(cleanResponseMain);
                    $('.section-popup').show();
                    $('#notifyForm')[0].reset();
                }
            }).fail(function(data) {
                const errors = data.responseJSON.errors
                console.log(errors);
            });
            return false;
        } else {
            $("#captcha-custom-error").removeClass("hide");
        }
      }
    });
});

$(document).on("click", ".section-popup .close", function(e){
    $('.section-popup').css('display','none');
    window.location.reload();
});